module.exports = __webpack_public_path__ + "img/Custom-Curl-Wave5@2x-1.5e16e953.jpg";